import React from 'react';
import styles from './popUp.css';

/**
 *
 * @type {React.NamedExoticComponent<{bgStyle?: *, children?: *, handleClose?: *, windowStyle?: *}>}
 */

const PopUp = React.memo( ( { children, handleClose, windowStyle, bgStyle } ) => {
    return (
        <div className={ styles.wrapper } onBlur={ () => {
            handleClose;
        } }>
            <div className={ styles.backStage } onClick={ handleClose } style={ bgStyle }/>
            <div className={ styles.window } style={ windowStyle }>
                { children }
            </div>
        </div>
    );
} );

export default PopUp;